import type { Config } from "../config.contract";
import { BaseEnvironment } from "./base.environment";

export class LocalEnvironment extends BaseEnvironment implements Config {
  /**
   * Webmotors base domain
   *
   */
  domain = "hportal.webmotors.com.br";

  /**
   * Local http protocol
   *
   */
  protocol: "http" | "https" = "http";

  /**
   * Enable logging for LOCAL Environment
   *
   */
  logging = true;

  /**
   * Disable sending headers
   *
   */
  disabledHeaders = true;

  /**
   * Webmotors api URL
   *
   */
  apiURL = `https://${this.domain}/api`;

  /**
   * Webmotors private api URL
   *
   */
  apiPrivateURL =
    "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api";

  /**
   * SEO private api URL
   *
   */
  seoApiPrivateURL =
    "https://sem3hlobfi-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api";

  /**
   * Webmotors base URL
   *
   */
  baseURL = `https://${this.domain}`;

  /**
   * Cookie domain on LOCAL environment
   *
   */
  cookieDomain = [
    this.domain,
    `.${this.domain}`,
    ".webmotors.com.br",
    "localhost",
  ];

  /**
   * Auth Cookie Name on LOCAL environment
   *
   */
  authCookieName = "webmotors.jwt.token.hk";

  /**
   * Access Token Cookie Name on LOCAL environment
   *
   */
  accessTokenCookieName = "webmotors.access.token";

  /**
   * Refresh Token Cookie Name on LOCAL environment
   *
   */
  refreshTokenCookieName = "webmotors.refresh.token.hk";

  /**
   * Vehicle photo path on LOCAL environment
   *
   */
  photoPath = "https://himage.webmotors.com.br";

  /**
   * Webmotors chat api websocket URL
   *
   */
  chatApiUrl = "wss://hchat.webmotors.com.br";

  /**
   * Hot deal image path on LOCAL environment
   *
   */
  hotDealImage = "https://image.webmotors.com.br/feiroes/imagens/hml/_portal/";
  /**
   * Data Dog Sample Config
   */
  traceSampleRate = 0;
  sessionSampleRate = 0;
  sessionReplaySampleRate = 0;

  /**
   * Seller shield image path
   */
  sellerShieldImage = "https://s3.amazonaws.com/webmotors/blindagem-fotos/hml/";

  /**
   * Login route
   *
   */
  loginRoute = `https://${this.domain}/login`;
}
